import Immutable, { Map, Iterable, fromJS } from 'immutable';

export const LOAD_IRREGULARDAYS = 'LOAD_IRREGULARDAYS';
export const UNLOAD_IRREGULARDAYS = 'UNLOAD_IRREGULARDAYS';
export const UPDATE_IRREGULARDAYS = 'UPDATE_IRREGULARDAYS';


export default function PlanningRequests(state, action) {

    switch(action.type) {

        case LOAD_IRREGULARDAYS:

            if(action.loading) {
                state = state.setIn(['loading'], true);
            }

            if(action.collection) {
                state = state.setIn(['collection'], Immutable.fromJS(action.collection).groupBy(x => x.get('id')).map(x => x.first()))
            }

            if(action.lastSynced) {
                state = state.setIn(['lastSynced'], action.lastSynced);
            }

            return state;
        case UNLOAD_IRREGULARDAYS:

            return state;
        case UPDATE_IRREGULARDAYS:

            if(action.single) {
                let single = Iterable.isIterable(action.single) ? action.single : fromJS(action.singe); 
                state = state.setIn(['collection', single.get('id')], single);
            }

            return state;

            default:
    }

    return state || Map();

}